import type { ColorName } from '@emotion/react';
import { EncounterClass, EncounterService } from '@quromedical/fhir-common';
import type { Field } from 'components/types';
import { strings } from 'strings';

/**
 * Currently these are all Home based, but when we add service types for hospital they will be added
 * here as well
 */
export const serviceClassMapping: Record<EncounterService, EncounterClass> = {
  [EncounterService.HospitalAtHome]: EncounterClass.Home,
  [EncounterService.TCP]: EncounterClass.Home,
  [EncounterService.RemotePatientMonitoring]: EncounterClass.Home,
  [EncounterService.Arthroplasty]: EncounterClass.Home,
  [EncounterService.HealingHands]: EncounterClass.Home,
  [EncounterService.InHospitalMonitoring]: EncounterClass.Hospital,
  [EncounterService.HospitalAtHomeUpgrade]: EncounterClass.Home,
  [EncounterService.SPHERE]: EncounterClass.Home,
};

export const statusColor: Partial<
  Record<fhir4.Encounter['status'], ColorName>
> = {
  'entered-in-error': 'status-critical',
  'in-progress': 'status-success',
  finished: 'accent-blue',
  onleave: 'accent-yellow',
};

export interface OxygenFields {
  hasOxygen: boolean;
  oxygen?: number;
}
export interface PregnancyFields {
  lactation: boolean;
  isPregnant: boolean;
  edd?: string;
}

export const getOxygenValue = (
  hasOxygen?: boolean,
  oxygen?: number,
): number | undefined => {
  if (!hasOxygen) {
    return undefined;
  }

  if (!oxygen) {
    return undefined;
  }

  return +oxygen;
};

export const createOxygenField = (hasOxygen = false): Field<OxygenFields> => ({
  subfields: [
    {
      key: 'hasOxygen',
      type: 'radio-group',
      label: strings.RequiredOxygenFormLabel,
      options: [
        {
          display: strings.FormLabelYes,
          value: true,
        },
        {
          display: strings.FormLabelNo,
          value: false,
        },
      ],
    },
    hasOxygen
      ? {
          key: 'oxygen',
          type: 'text-box',
          label: strings.RequiredOxygenQuantityFormLabel,
          keyboardType: 'numeric',
        }
      : {
          key: 'oxygen',
          type: 'custom',
          label: '',
          background: false,
          Display: () => null,
          isDisabled: true,
        },
  ],
});

const startDate = new Date();
const start = new Date();
const endDate = new Date(start.setMonth(start.getMonth() + 12));

export const createPregnancyField = (
  pregnancy = false,
): Field<PregnancyFields>[] => [
  {
    subfields: [
      {
        key: 'isPregnant',
        type: 'radio-group',
        label: strings.FormLabelIsPregnant,
        options: [
          {
            display: strings.FormLabelYes,
            value: true,
          },
          {
            display: strings.FormLabelNo,
            value: false,
          },
        ],
      },
      {
        key: 'lactation',
        type: 'radio-group',
        label: strings.FormLabelIsLactating,
        options: [
          {
            display: strings.FormLabelYes,
            value: true,
          },
          {
            display: strings.FormLabelNo,
            value: false,
          },
        ],
      },
    ],
  },
  {
    subfields: [
      pregnancy
        ? {
            key: 'edd',
            type: 'date-component',
            label: strings.FormLabelEDD,
            maskType: 'date',
            validRange: { startDate, endDate },
          }
        : {
            key: 'edd',
            type: 'custom',
            label: '',
            background: false,
            Display: () => null,
            isDisabled: true,
          },
    ],
  },
];
